import type { IError } from "@somewear/model";
import { RenderIf } from "@somewear/ui";
import * as Common from "@web/common/Common";
import type { IControlledInput } from "@web/common/ControlledInputController";
import Paths from "@web/common/Paths";
import * as React from "react";
import { Link } from "react-router-dom";

import Config from "../config/Config";
import * as LandingCommon from "./LandingCommon";

interface IProps {
	error?: IError;
	emailInput: IControlledInput;
	passwordInput: IControlledInput;
	mailLogin(evt?: React.FormEvent<HTMLButtonElement>): void;
	showReset(): void;
	useFirebase: boolean;
}

const LoginView: React.FunctionComponent<IProps> = (props: IProps) => (
	<div className="mx-2 w-full md:w-auto md:min-w-96">
		<form>
			<div>
				<LandingCommon.CenterHeader text="Sign in" />
				<LandingCommon.ErrorMessage error={props.error} className="max-w-input" />
				<LandingCommon.FirstInput error={props.error}>
					<LandingCommon.ControlledInputView
						type={props.useFirebase ? "email" : "text"}
						id="email"
						placeholder={props.useFirebase ? "Email" : "Email / Username"}
						value={props.emailInput.getValue()}
						controlledInput={props.emailInput}
						required
					/>
				</LandingCommon.FirstInput>
				<div>
					<LandingCommon.ControlledInputView
						type="password"
						id="password"
						placeholder="Password"
						value={props.passwordInput.getValue()}
						controlledInput={props.passwordInput}
						required
					/>
				</div>
				<Common.CenterContent>
					<LandingCommon.Button onClick={(evt) => props.mailLogin(evt)}>
						<Common.TitleButtonText>Sign in</Common.TitleButtonText>
					</LandingCommon.Button>
				</Common.CenterContent>
				<Common.CenterContent>
					<Link to={Paths.Root}>
						<LandingCommon.LinkButton className="mt-2.5">Back</LandingCommon.LinkButton>
					</Link>
				</Common.CenterContent>
				<RenderIf condition={Config.firebase.enable}>
					<Common.CenterContent>
						<LandingCommon.LinkButton
							className="mt-10 md:fixed md:bottom-16"
							onClick={() => props.showReset()}
							role="button"
						>
							Forgot password?
						</LandingCommon.LinkButton>
					</Common.CenterContent>
				</RenderIf>
				<Common.CenterContent>
					<div className="text-sm text-gray-600 text-center mt-10 md:mt-0 mb-5 md:mb-0 static md:fixed md:bottom-5 tracking-wide leading-tight">
						Need an account?
						<Link to={Paths.Signup}>
							<span className="text-blue-500 font-bold cursor-pointer uppercase">
								{" "}
								Sign up{" "}
							</span>
						</Link>
					</div>
				</Common.CenterContent>
			</div>
		</form>
	</div>
);

export default LoginView;
